import { mergeAttributes, Node } from '@tiptap/react';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { ImageLoadingNode as ImageLoadingNodeComponent } from 'shared-components/components/TipTap/tiptap-node/image-loading-node/image-loading-node';

/**
 * A Tiptap block node that renders a shimmer placeholder whilst an image is uploading.
 * Insert this node immediately after a file is chosen, then replace it with the real
 * `image` node once the upload resolves.
 */
export const ImageLoadingNode = Node.create({
  name: 'imageLoading',

  group: 'block',

  atom: true,

  selectable: false,

  draggable: false,

  addAttributes() {
    return {
      /** Unique identifier used to locate and replace this placeholder after upload. */
      id: { default: null },
      /** Blob URL of the local file shown as a preview whilst the upload is in flight. */
      src: { default: null },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="image-loading"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes({ 'data-type': 'image-loading' }, HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageLoadingNodeComponent);
  },
});

export default ImageLoadingNode;
